import { Historie } from './historie';

export class TagebuchEintragHistorie {
  constructor({
    datum,
    historie,
  }: {
    readonly datum: string;
    readonly historie: Historie;
  }) {
    this.datum = datum;
    this.historie = historie;
  }

  readonly datum: string;
  readonly historie: Historie;
}
